import styled from '@emotion/styled/macro';
import { Variables } from '../base/variables';

const V = Variables.ThemeLight;

/** Name, HALTED badge and subtitle, stacked in the identity cell. */
export const Identity = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    overflow: hidden;
`;

export const NameRow = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
`;

export const Name = styled.span`
    font-weight: 500;
    font-size: 13px;
    color: ${V.TextStrong};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

/**
 * Halt is the exceptional state, so it is a badge rather than a column reading "Active" four
 * hundred times. `nowrap` because HALTED broke into "HALTE / D" in a narrow cell.
 */
export const Halted = styled.span`
    display: inline-flex;
    align-items: center;
    flex: none;
    padding: 1px 5px;
    border-radius: 3px;
    font: 700 9px/1.5 var(--font-sans, inherit);
    white-space: nowrap;
    color: ${V.WarningInverted4};
    background: ${V.WarningMild3};
`;

export const Sub = styled.span`
    font-size: 11px;
    color: ${V.TextMild};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

/** The clearinghouse cell: a name row and a meta line beneath it. */
export const Cell = styled.div`
    display: flex;
    flex-direction: column;
    gap: 3px;
    min-width: 0;
`;

/** "+2 more" — the design shows the first connection and counts the rest. */
export const More = styled.span`
    display: inline-flex;
    align-items: center;
    flex: none;
    padding: 1px 6px;
    border-radius: 4px;
    font: 500 10px/1.5 var(--font-sans, inherit);
    white-space: nowrap;
    color: ${V.TextMedium};
    background: ${V.Background3};
`;

export const Meta = styled.span`
    font-size: 11px;
    color: ${V.TextMild};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

/** Chevron in the expander column; rotates when the row is open. */
export const Chevron = styled.span<{ expanded: boolean }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${V.TextMild};
    transition: transform 120ms ease-out;
    transform: rotate(${({ expanded }) => (expanded ? '90deg' : '0deg')});
`;
